// Liste ekranının filtre + sıralaması (lead kartındaki "sonraki" düğmesi
// bu bağlamı sunucuya gönderir).
//
// Önce sekmeye özel sessionStorage: iki sekmede farklı listeyle çalışan
// kullanıcı, eskiden ortak localStorage yüzünden diğer sekmenin filtresiyle
// ilerliyordu. localStorage yedek olarak yazılmaya devam eder (yeni sekmede
// açılan kart, eski davranış).

export function saveListContext(key, context) {
  const value = JSON.stringify(context);
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    /* depolama kapalı */
  }
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    /* depolama kapalı */
  }
}

export function readListContext(key) {
  const sources = [];
  try {
    sources.push(sessionStorage.getItem(key));
  } catch (e) {
    /* yoksay */
  }
  try {
    sources.push(localStorage.getItem(key));
  } catch (e) {
    /* yoksay */
  }
  for (const raw of sources) {
    if (!raw) continue;
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return parsed;
    } catch (e) {
      // Bozuk kayıt kartın açılmasını engellemesin; sıradakine bak.
    }
  }
  return null;
}
